

export const ROUTES = {
CLAIMS: '/claims',
CLAIM_EDIT: (CLAIM_ID)=>`/claims/edit/${CLAIM_ID}`
};